<ul class="pagination pagination-sm m-t-none" ng-if="pages.numbers.length > 1">
  <li ng-class="{disabled: !pages.pagination.first || pages.pagination.first == (filters.page || currentPage)}">
    <a href="" ng-click="setPage(pages.pagination.first)">&laquo;</a>
  </li>
  <li ng-class="{disabled: !pages.pagination.prev || pages.pagination.prev == (filters.page || currentPage)}">
    <a href="" ng-click="setPage(pages.pagination.prev)">&lsaquo;</a>
  </li>

  <li ng-repeat="page in pages.numbers track by $index" ng-class="{active: page == ((filters.page || currentPage) || 1)}">
    <a href="" ng-click="setPage(page)">{{page}}</a>
  </li>

  <li ng-class="{disabled: !pages.pagination.next || pages.pagination.next == (filters.page || currentPage)}">
    <a href="" ng-click="setPage(pages.pagination.next)">&rsaquo;</a>
  </li>
  <li ng-class="{disabled: !pages.pagination.last || pages.pagination.last == (filters.page || currentPage)}">
    <a href="" ng-click="setPage(pages.pagination.last)">&raquo;</a>
  </li>
</ul>
